module.exports = __webpack_public_path__ + "img/DocumentBlank.34694707.svg";